import React, {useLayoutEffect, useRef, useState} from "react"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard"
import {useForceUpdate} from "../../../../../core/gd/utils/dom-and-react/react-utils"
import QuickSearch_Settings from "../settings/settings";
import QuickSearch from "../../model/quick-search";

type Props = {
    quickSearch     : QuickSearch
    onCloseModal    : callback
}

// const debug = "ModalGoToMain_Header"
const debug = false

export default function QuickSearch_Header(props: Props) {

    const forceUpdate = useForceUpdate()
    const [value, setValue] = useState<string>('')

    const refInput: any = useRef()


    useLayoutEffect(() => {
        //timeout for focus because shortcut appeared in it right away
        if (refInput.current) {
            setTimeout(()=>{
                refInput.current.focus()
            }, 0)
        }

        return ()=> {
        }
    }, []);

    const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value ? event.target.value : ''
        setValue(value)

        props.quickSearch.setQuery(value)
    }



    const onAdvancedSearch = () => {
        gd.modal.hide()
        gd.navigation.goTo('search')
    }

    const cancelSearch = () => {
        props.quickSearch.cancel()
        forceUpdate()
    }


    debug && console.log(debug, 'render', gd.user.settings.quickSearch.toJson())

    return (
        <div className="header">

            <div className="flex-row-center-between">

                <div className="flex-row-left-center">
                    <div className="title">Quick Search</div>

                    <div className="ui5-horizontal-separator m-l-15 m-r-15" style={{height: '14px'}}/>


                    <div className="ui5-link-default flex-row-left-center m-r-20" onClick={onAdvancedSearch}>
                        <div className="ui5-ico-14 i5-open-new-window action m-r-8"/>
                        Advanced Search
                    </div>
                </div>

                <div className="m-r-20">
                    <QuickSearch_Settings quickSearch={props.quickSearch} />
                </div>

            </div>



            <div className="search">
                <input ref          = {refInput}
                       className    = "gd-input big"
                       type         = "input"
                       placeholder  = "Search..."
                       value        = {props.quickSearch.query}
                       onChange     = {onSearchChange}/>
                <div className="i5-search"/>

                {!!props.quickSearch.searchEnabled &&
                    <div className="i5-delete" onClick={cancelSearch} />
                }
            </div>


            {/* Modal close*/}
            <ControlButtonStandard className    = "btn-close"
                                   type         = {ControlButtonType.CLOSE}
                                   onClick      = {props.onCloseModal}/>
        </div>
    )
}
